export default __webpack_public_path__ + "static/media/Chilled.17c39454.svg";